import imageMapResize from 'image-map-resizer';
/**
 * Enables the common functionality.
 */
const enableCommonFunctionality = () => {
    imageMapResize('map');
};
export default enableCommonFunctionality;
